let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("lkJNx"), load("dWaws"), load("6Fqtz")]).then(() => parcelRequire('k13Km'));